import _ from 'lodash';

export const isTooltipVisible = (
  tooltipId: string,
  visibleTooltips: string
) => {
  return !!_.find(visibleTooltips.split(','), (t) => t === tooltipId);
};
